export const normalizeYaw = (yaw: number) =>
    ((((yaw % 360) + 360) % 360) + 360) % 360

export const toHeadingLabel = (yaw: number) => {
    const d = ((yaw % 360) + 360) % 360;
    if (d >= 337.5 || d < 22.5) return "Bắc (N)";
    if (d >= 22.5 && d < 67.5) return "Đông Bắc (NE)";
    if (d >= 67.5 && d < 112.5) return "Đông (E)";
    if (d >= 112.5 && d < 157.5) return "Đông Nam (SE)";
    if (d >= 157.5 && d < 202.5) return "Nam (S)";
    if (d >= 202.5 && d < 247.5) return "Tây Nam (SW)";
    if (d >= 247.5 && d < 292.5) return "Tây (W)";
    return "Tây Bắc (NW)";
}